import { activityLogActionTypes } from '@Actions/activityLogActions';

const ActivityLogReducers = (state = {}, action) => {
  switch (action.type) {
    case activityLogActionTypes.GET_ACTIVITY_LOG.LOADING: {
      const { getActivityLogLoading, entityName } = action;

      if (entityName === 'purchase_requisition') {
        return {
          ...state,
          getActivityLogPRLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'purchase_indent') {
        return {
          ...state,
          getActivityLogPILoading: getActivityLogLoading,
        };
      }
      if (entityName === 'purchase_order') {
        return {
          ...state,
          getActivityLogPOLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'good_receiving_note') {
        return {
          ...state,
          getActivityLogGRNLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'account_payable_invoice') {
        return {
          ...state,
          getActivityLogAPInvoiceLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'sales_order') {
        return {
          ...state,
          getActivityLogSOLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'annual_maintenance_contract') {
        return {
          ...state,
          getActivityLogAMCLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'packing_slip') {
        return {
          ...state,
          getActivityLogPSLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'invoice') {
        return {
          ...state,
          getActivityLogInvoiceLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'consumption_order') {
        return {
          ...state,
          getActivityLogCOLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'manufacturing_order') {
        return {
          ...state,
          getActivityLogMOLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'vendor_payout') {
        return {
          ...state,
          getActivityLogVendorPayoutLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'stock_transfer') {
        return {
          ...state,
          getActivityLogStockTransferLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'debit_note') {
        return {
          ...state,
          getActivityLogDebitNoteLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'credit_note') {
        return {
          ...state,
          getActivityLogCreditNoteLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'return_slip') {
        return {
          ...state,
          getActivityLogReturnSlipLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'sales_estimate') {
        return {
          ...state,
          getActivityLogEstimateLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'packing_slip') {
        return {
          ...state,
          getActivityLogPackingSlipLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'gate_document') {
        return {
          ...state,
          getActivityLogGateDocumentLoading: getActivityLogLoading,
        };
      }
      if (entityName === 'product') {
        return {
          ...state,
          getActivityLogProductLoading: getActivityLogLoading
        };
      }
      if (entityName === 'sku_offer') {
        return {
          ...state,
          getActivityOfferLogProductLoading: getActivityLogLoading
        };
      }
      if (entityName === 'delivery_challan') {
        return {
          ...state,
          getActivityLogDeliveryChallanLoading: getActivityLogLoading,
        };
      }
      // return {
      //   ...state,
      //   getActivityLogLoading,
      //   entityName,
      // };
    }

    case activityLogActionTypes.GET_ACTIVITY_LOG.SUCCESS: {
      const { activityLog, entityName } = action;
      if (activityLog?.page > 1) {
        if (entityName === 'purchase_requisition') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogPR));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogPR: activityLogCopy,
          };
        }
        if (entityName === 'purchase_indent') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogPI));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogPI: activityLogCopy,
          };
        }
        if (entityName === 'purchase_order') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogPO));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogPO: activityLogCopy,
          };
        }
        if (entityName === 'good_receiving_note') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogGRN));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogGRN: activityLogCopy,
          };
        }
        if (entityName === 'account_payable_invoice') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogAPInvoice));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogAPInvoice: activityLogCopy,
          };
        }
        if (entityName === 'sales_order') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogSO));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogSO: activityLogCopy,
          };
        }
        if (entityName === 'annual_maintenance_contract') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogAMC));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogAMC: activityLogCopy,
          };
        }
        if (entityName === 'packing_slip') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogPackingSlip));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogPackingSlip: activityLogCopy,
          };
        }
        if (entityName === 'gate_document') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogGateDocument));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogGateDocument: activityLogCopy,
          };
        }
        if (entityName === 'invoice') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogInvoice));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogInvoice: activityLogCopy,
          };
        }
        if (entityName === 'consumption_order') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogCO));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogCO: activityLogCopy,
          };
        }
        if (entityName === 'manufacturing_order') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogMO));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogMO: activityLogCopy,
          };
        }
        if (entityName === 'vendor_payout') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogVendorPayout));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogVendorPayout: activityLogCopy,
          };
        }
        if (entityName === 'stock_transfer') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogStockTransfer));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogStockTransfer: activityLogCopy,
          };
        }
        if (entityName === 'debit_note') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogDebitNote));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogDebitNote: activityLogCopy,
          };
        }
        if (entityName === 'credit_note') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogCreditNote));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogCreditNote: activityLogCopy,
          };
        }
        if (entityName === 'return_slip') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogReturnSlip));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogReturnSlip: activityLogCopy,
          };
        }
        if (entityName === 'sales_estimate') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogEstimate));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogEstimate: activityLogCopy,
          };
        }
        if (entityName === 'packing_slip') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogPackingSlip));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogEstimate: activityLogCopy,
          };
        }
        if (entityName === 'gate_document') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogGateDocument));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogGateDocument: activityLogCopy,
          };
        }
        if (entityName === 'product') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogProduct));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogProduct: activityLogCopy,
          };
        }
        if (entityName === 'sku_offer') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityOfferLogProduct));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityOfferLogProduct: activityLogCopy,
          };
        }
        if (entityName === 'delivery_challan') {
          const activityLogCopy = JSON.parse(JSON.stringify(state.activityLogDeliveryChallan));
          activityLogCopy.data = [...activityLogCopy.data, ...activityLog?.data];
          return {
            ...state,
            activityLogDeliveryChallan: activityLogCopy,
          };
        }
      } else {
        if (entityName === 'purchase_requisition') {
          return {
            ...state,
            activityLogPR: activityLog,
          };
        }
        if (entityName === 'purchase_indent') {
          return {
            ...state,
            activityLogPI: activityLog,
          };
        }
        if (entityName === 'purchase_order') {
          return {
            ...state,
            activityLogPO: activityLog,
          };
        }
        if (entityName === 'good_receiving_note') {
          return {
            ...state,
            activityLogGRN: activityLog,
          };
        }
        if (entityName === 'account_payable_invoice') {
          return {
            ...state,
            activityLogAPInvoice: activityLog,
          };
        }
        if (entityName === 'sales_order') {
          return {
            ...state,
            activityLogSO: activityLog,
          };
        }
        if (entityName === 'annual_maintenance_contract') {
          return {
            ...state,
            activityLogAMC: activityLog,
          };
        }
        if (entityName === 'packing_slip') {
          return {
            ...state,
            activityLogPackingSlip: activityLog,
          };
        }
        if (entityName === 'gate_document') {
          return {
            ...state,
            activityLogGateDocument: activityLog,
          };
        }
        if (entityName === 'invoice') {
          return {
            ...state,
            activityLogInvoice: activityLog,
          };
        }
        if (entityName === 'consumption_order') {
          return {
            ...state,
            activityLogCO: activityLog,
          };
        }
        if (entityName === 'manufacturing_order') {
          return {
            ...state,
            activityLogMO: activityLog,
          };
        }
        if (entityName === 'vendor_payout') {
          return {
            ...state,
            activityLogVendorPayout: activityLog,
          };
        }
        if (entityName === 'stock_transfer') {
          return {
            ...state,
            activityLogStockTransfer: activityLog,
          };
        }
        if (entityName === 'debit_note') {
          return {
            ...state,
            activityLogDebitNote: activityLog,
          };
        }
        if (entityName === 'credit_note') {
          return {
            ...state,
            activityLogCreditNote: activityLog,
          };
        }
        if (entityName === 'return_slip') {
          return {
            ...state,
            activityLogReturnSlip: activityLog,
          };
        }
        if (entityName === 'sales_estimate') {
          return {
            ...state,
            activityLogEstimate: activityLog,
          };
        }
        if (entityName === 'packing_slip') {
          return {
            ...state,
            activityLogPackingSlip: activityLog,
          };
        }
        if (entityName === 'gate_document') {
          return {
            ...state,
            activityLogGateDocument: activityLog,
          };
        }
        if (entityName === 'product') {
          return {
            ...state,
            activityLogProduct: activityLog,
          };
        }
        if (entityName === 'sku_offer') {
          return {
            ...state,
            activityOfferLogProduct: activityLog,
          };
        }
        if (entityName === 'delivery_challan') {
          return {
            ...state,
            activityLogDeliveryChallan: activityLog,
          };
        }
      }
    }

    case activityLogActionTypes.ADD_ACTIVITY_LOG.LOADING: {
      const { addActivityLogLoading } = action;
      return {
        ...state,
        addActivityLogLoading,
      };
    }
    case activityLogActionTypes.EDIT_ACTIVITY_LOG.LOADING: {
      const { editActivityLogLoading } = action;
      return {
        ...state,
        editActivityLogLoading,
      };
    }
    case activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.LOADING: {
      const { getHistoryActivityLogLoading } = action;
      return {
        ...state,
        getHistoryActivityLogLoading,
      };
    }
    case activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.SUCCESS: {
      const { activityLogHistoryComments } = action;
      return {
        ...state,
        activityLogHistoryComments,
      };
    }
    default: {
      return state;
    }
  }
};

export default ActivityLogReducers;
